<div class="page-container carrier-portal-container container">
  <div class="row w-100 m-0">
    <app-utility-toolbar
      [current]="current"
      [vertical]="true"
      (toggleCollapse)="toggleNavCollapse()"
      class="{{ navCollapsed ? 'w-5' : 'w-15' }} vertical"
      [links]="bmLinks"
    ></app-utility-toolbar>

    <div class="content-container pl-3" [ngClass]="{ collapsed: navCollapsed }">
      @if (current === 'carrier-portal') {
        <h1 class="header col-12 mb-2"> Carrier Partner Portal </h1>

        <app-bm-widget-filters
          [viewMode]="'carrier'"
          [minDate]="minDate"
          [defaultRange]="'30 days'"
        ></app-bm-widget-filters>

        <div class="home-office-container">
          <div class="row">
            <app-contract-stats
              class="col-12"
              [reportName]="'PM Carrier Contract Totals'"
            ></app-contract-stats>
          </div>

          <div class="row">
            <app-contract-summary
              class="col-12"
              [reportName]="'PM Carrier Contract Summary'"
              [headerType]="'carrier'"
            ></app-contract-summary>
          </div>

          <div class="row">
            <app-top-performers
              class="col-12"
              [title]="'Top Performers'"
              [configType]="'carrier-top-performers'"
              [reportName]="'PM Carrier Top Performers'"
            ></app-top-performers>
          </div>
        </div>
      } @else if (current === 'carrier-policy-details') {
        <app-carrier-policy-details></app-carrier-policy-details>
      }
    </div>
  </div>
</div>
